/// <reference types="chrome" />
import { Button } from "components/ui";
import { useState, useEffect } from "react";
import { useApi } from "hooks/api";
import { useAuth } from "hooks/auth";
import { useMutation } from "react-query";
import { OAuthToken } from "types/qbank/token";
import LinkImage from "./LinkImage";


export default function Login() {
  const { setAuth } = useAuth();
  //const { api, login } = useApi();
  const { api, loginWithCode } = useApi();
  const [logoutReason, setLogoutReason] = useState<string>("");
  const [errors, setErrors] = useState({
    host: false,
    username: false,
    password: false,
  });
  const [host, setHost] = useState(api.host);
  const [authLoading, setAuthLoading] = useState<boolean>(false);
  const [os, setOs] = useState<string | null>(null);
  const [isPop, setIsPop] = useState(true);
  const [isSidebar, setIsSidebar] = useState(false);


  const { mutate: loginMutation, isLoading } = useMutation(loginWithCode, {
    onSuccess: (data: OAuthToken) => {
      setAuth({ isLoggedIn: true, oAuthToken: data });
    },
    onError: (error: any) => {
      setLogoutReason("Could not login with the given credentials");
    },
  });

  const readAndClearStorage = () => {
    // Read from chrome.storage.sync (can also be 'local' if needed)
    chrome.storage.sync.get(null, (items) => {
      if (items["token"] != null) {
        const clientId = process.env.REACT_APP_client_id || "";
        const redirectUri = chrome.identity.getRedirectURL();
        loginMutation({ host, clientId, code: items["token"], redirect_uri: redirectUri })
        // Clear the storage after reading
        chrome.storage.sync.clear(() => {
          console.log('Storage cleared');
        });
      }
    });
  };

  useEffect(() => {
    const detectOS = () => {
      const platform = window.navigator.platform.toLowerCase();
      const userAgent = window.navigator.userAgent.toLowerCase();

      if (platform.includes('win')) {
        setOs('Windows');
      } else if (platform.includes('mac') || userAgent.includes('macintosh')) {
        setOs('Mac');
        readAndClearStorage();
      } else {
        setOs('Unknown OS');
        readAndClearStorage();
      }
    };
    detectOS();
    const queryParams = new URLSearchParams(window.location.search);
    setIsPop(queryParams.get('popup') === 'true');
    setIsSidebar(queryParams.get('sidebar') === 'true');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const resizeAndCenterWindow = (windowId: number, width: number, height: number) => {
    // Get the current window 
    chrome.windows.get(windowId, { populate: false }, (currentWindow) => {
      if (!currentWindow) {
        console.error('Could not get the current window.');
        return;
      }

      // Get screen dimensions of all displays(muliple display scenario)
      chrome.system.display.getInfo((displays) => {
        // Determine the display the current window is on
        const currentDisplay = displays.find(display => {
          const { left, top, width, height } = display.workArea;
          return (
            currentWindow.left! >= left &&
            currentWindow.left! < left + width &&
            currentWindow.top! >= top &&
            currentWindow.top! < top + height
          );
        });

        if (!currentDisplay) {
          console.error('Could not determine the current display.');
          return;
        }

        // Calculate center position based on the current display
        const left = Math.round(currentDisplay.workArea.left + (currentDisplay.workArea.width - width) / 2);
        const top = Math.round(currentDisplay.workArea.top + (currentDisplay.workArea.height - height) / 2);

        // Update the window size and position
        chrome.windows.update(windowId, {
          width: width,
          height: height,
          left: left,
          top: top
        }, () => {
          if (chrome.runtime.lastError) {
            console.error(chrome.runtime.lastError.message);
          }
        });
      });
    });
  }

  const resizeAuthWindowOnCreated = (width: number, height: number) => {

    chrome.windows.onCreated.addListener(function resizePopup(win) {

      if (win && win.id) {
        resizeAndCenterWindow(win.id, width, height);
        chrome.windows.onCreated.removeListener(resizePopup);
      }
    }, { windowTypes: ['popup'] })
  }

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!host.length) {
      setErrors({
        host: !!host.length,
        username: false,
        password: false,
      });
    } else {
      localStorage.setItem("host", host);
      setErrors({
        host: false,
        username: false,
        password: false,
      });
    }
    try {
      setAuthLoading(true);
      const clientId = process.env.REACT_APP_client_id || "";
      const redirectUri = chrome.identity.getRedirectURL();
      const authUrl = `https://${host}/api/oauth2/authorize.html?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}`;

      if (os !== "Windows" && !isPop && !isSidebar) {
        chrome.runtime.sendMessage({ action: 'startAuthFlow', Url: authUrl });
      }
      else {
      resizeAuthWindowOnCreated(900, 680);
      chrome.identity.launchWebAuthFlow(
        { url: authUrl, interactive: true },
        function (redirectUrl) {
          if (chrome.runtime.lastError) {
            console.error(chrome.runtime.lastError);
            setLogoutReason("The authorization page could not be loaded.");
            setAuthLoading(false);
            return;
          }

          if (redirectUrl) {
            const urlParams = new URLSearchParams(new URL(redirectUrl).search);
            const authToken = urlParams.get('code');

            if (authToken) {
              loginMutation({ host, clientId, code: authToken, redirect_uri: redirectUri })
            }
            else {
              setErrors({
                host: false,
                username: false,
                password: false,
              });
            }
            setAuthLoading(false);
          }
        }
      );
      }
    }
    catch (ex) {
      console.error(ex)
      setAuthLoading(false);
    }

  };


  return (
    <div className="connector-body-login">
      <div className="login-wrapper">
        <div className="login-container">
          <div className="text-heading p-bottom-2 p-left-10">Login</div>
          <div className="text-subheading p-bottom-16 p-left-10">QBank Browser connector</div>
          <form onSubmit={handleSubmit} className="full-width">
          {logoutReason && <span className="bad-details">{logoutReason}</span>}
            <div className="text-normal p-left-10">Host name</div>
            <div >
            <input
              type="text"
              value={host}
                onChange={(e) => setHost(e.target.value)}
              required={true}
                className={errors.host ? "error" : "input-basic"}
              />
          </div>
            <div className="center-alligned-button-container full-width">
          <Button
                className="button-primary full-width"
            type="submit"
            loading={isLoading || authLoading}
            icon={isLoading || authLoading ? "cog" : "sign-in-alt"}
            disabled={isLoading || authLoading}
          >
                Continue
          </Button>
            </div>
        </form>
          <div className="login-information-panel"
            onClick={() => {
              window.open(
                "https://knowledge.qbankdam.com/knowledge/using-the-chrome-connector",
                "_blank"
              );
            }}
          >
            <div className="content-container">
              <p>
                Learn more about the QBank connector
              </p>
            </div>
            <div className="image-container">
              <LinkImage />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
